<template>
    <button :disabled="isLoading" @click.prevent="click" >
        <icon v-if="isLoading" icon="circle-notch" spin/>
        <slot/>
    </button>
</template>

<script>

    import Icon from "../Icon";

    export default {
        name: 'IndicatorButton',
        props: {
            isLoading:{
                default: false
            },
            click:{}
        },
        components:{
            Icon
        }

    }
</script>

<style lang="sass">

</style>



// WEBPACK FOOTER //
// src/components/ui/buttons/IndicatorButton.vue